export default __webpack_public_path__ + "static/media/generalBlack.ebefd6a5.svg";